import { render, staticRenderFns } from "./OfferReasonsSection.vue?vue&type=template&id=0dd51e9a&scoped=true"
import script from "./OfferReasonsSection.vue?vue&type=script&lang=js"
export * from "./OfferReasonsSection.vue?vue&type=script&lang=js"
import style0 from "./OfferReasonsSection.vue?vue&type=style&index=0&id=0dd51e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd51e9a",
  null
  
)

export default component.exports